"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addStyle = exports.addScript = void 0;
function loadError(error) {
    throw new URIError("The script ".concat(error.target.src, " is not accessible."));
}
function appendScript(src, callback) {
    var body = document.body || document.getElementsByTagName('body')[0];
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.onerror = loadError;
    script.onload = callback;
    body.appendChild(script);
    script.src = src;
}
function addScript(src, callback) {
    var _a = window, define = _a.define, require = _a.require;
    if (define && define.amd) {
        // viewer require-js found
        require([src], callback);
        return;
    }
    if (document.readyState === 'complete' ||
        document.readyState === 'interactive') {
        appendScript(src, callback);
    }
    else {
        document.addEventListener('DOMContentLoaded', function () {
            appendScript(src, callback);
        });
    }
}
exports.addScript = addScript;
function addStyle(src) {
    var link = document.createElement('link');
    link.type = 'text/css';
    link.href = src;
    link.rel = 'stylesheet';
    document.getElementsByTagName('head')[0].appendChild(link);
}
exports.addStyle = addStyle;
//# sourceMappingURL=load.js.map